export enum AuthActions {
	LOGIN = '[Auth] login',
	LOGIN_ERROR = '[Auth] Login Error',
	RESET_STATE = '[Auth] Reset State',
	SET_TIME_TO_EXPIRE = '[Auth] Set Time To Expire',
}
